module.exports = __webpack_public_path__ + "img/104.a379095f.jpg";